import TwoByStatTable from "./TwoByStatTable";

## Basic Usage

<TwoByStatTable>
  <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "24px", fontWeight: 600 }}>1,234</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Total Users</div>
  </div>
  <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "24px", fontWeight: 600 }}>567</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Active Today</div>
  </div>
</TwoByStatTable>

---

## Four Stats (2x2 Grid)

<TwoByStatTable>
  <div style={{ textAlign: "center", padding: "1rem" }}>
    <div style={{ fontSize: "28px", fontWeight: 600, color: "#3b82f6" }}>$45.2K</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Revenue</div>
  </div>
  <div style={{ textAlign: "center", padding: "1rem" }}>
    <div style={{ fontSize: "28px", fontWeight: 600, color: "#22c55e" }}>+12.5%</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Growth</div>
  </div>
  <div style={{ textAlign: "center", padding: "1rem" }}>
    <div style={{ fontSize: "28px", fontWeight: 600 }}>892</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Orders</div>
  </div>
  <div style={{ textAlign: "center", padding: "1rem" }}>
    <div style={{ fontSize: "28px", fontWeight: 600 }}>4.8</div>
    <div style={{ color: "#666", fontSize: "14px" }}>Avg Rating</div>
  </div>
</TwoByStatTable>

---

## With Custom Styling

<TwoByStatTable gap="2rem" padding="1.5rem" background="#f9fafb" borderRadius="12px">
  <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "32px", fontWeight: 700 }}>99.9%</div>
    <div style={{ color: "#666" }}>Uptime</div>
  </div>
  <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "32px", fontWeight: 700 }}>42ms</div>
    <div style={{ color: "#666" }}>Latency</div>
  </div>
</TwoByStatTable>

---

## Dashboard Card Example

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem" }}>
  <h4 style={{ margin: "0 0 1rem" }}>Project Statistics</h4>
  <TwoByStatTable>
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "20px", fontWeight: 600 }}>24</div>
      <div style={{ color: "#666", fontSize: "13px" }}>Open Tasks</div>
    </div>
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "20px", fontWeight: 600 }}>156</div>
      <div style={{ color: "#666", fontSize: "13px" }}>Completed</div>
    </div>
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "20px", fontWeight: 600 }}>8</div>
      <div style={{ color: "#666", fontSize: "13px" }}>Team Members</div>
    </div>
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "20px", fontWeight: 600 }}>3</div>
      <div style={{ color: "#666", fontSize: "13px" }}>Days Left</div>
    </div>
  </TwoByStatTable>
</div>

---

## Comparison Stats

<TwoByStatTable>
  <div style={{ textAlign: "center", padding: "0.5rem" }}>
    <div style={{ fontSize: "12px", color: "#666", marginBottom: "0.25rem" }}>This Month</div>
    <div style={{ fontSize: "24px", fontWeight: 600 }}>$12,450</div>
  </div>
  <div style={{ textAlign: "center", padding: "0.5rem" }}>
    <div style={{ fontSize: "12px", color: "#666", marginBottom: "0.25rem" }}>Last Month</div>
    <div style={{ fontSize: "24px", fontWeight: 600 }}>$10,230</div>
  </div>
</TwoByStatTable>

